module.exports = __webpack_public_path__ + "static/media/hawaiian_dream.goldenhero.3dbdd10f.jpeg";